import LocationContent from "$lib/data/generated/content/location/data.json";

import { uploads as LocationUploads } from "$lib/data/generated/uploads/location/uploads";

const content = {
	["location"]: LocationContent
};
const uploads = {
	...LocationUploads
};


export const prerender = 'auto';
export const entries = () => {
	if (false) return [];
	return ['/admin'];
};

export const load = async ({ parent }) => {
	const data = await parent();

	data.content = { ...data.content, ...content };
	data.uploads = { ...data.uploads, ...uploads };

	return data;
};
